import { ClientSession } from "./ClientSessionHolder";
// List of metro domain names. This is necessary for sync with sitecore to get domain name without subdomains.
const METRO_DOMAINS = ["metro", "makro", "metro-cc"];
export const ApiUrlUtil = {
	getDomain: function (): string {
		return document.location.hostname;
	},
	isMetroDomainName: function (domainName: string): boolean {
		return METRO_DOMAINS.indexOf(domainName) !== -1;
	},
	// Expects a domain like 'lieferservice.metro.de' and returns 'metro.de'.
	// Used to set the sitecore cookies for the correct domain.
	getDomainNameWithoutSubdomains: function (domain: string): string {
		const parts = domain.split(".");
		let subParts;

		for (let i = 2; i < parts.length; i++) {
			subParts = parts.slice(i * -1);

			if (this.isMetroDomainName(subParts[0])) {
				return subParts.join(".");
			}
		}

		return domain;
	},
	manualXMLHttpRequest: function (
		url: string,
		method: string,
		content: Record<string, any> | null,
		completed: (...args: Array<any>) => any,
		failure: (...args: Array<any>) => any,
		timeout?: number,
		callTreeId?: string,
	) {
		this.manualXMLHttpRequestInternal(
			new XMLHttpRequest(),
			url,
			method,
			content,
			completed,
			failure,
			timeout,
			callTreeId,
		);
	},
	manualXMLHttpRequestInternal: function (
		xhttp: XMLHttpRequest,
		url: string,
		method: string,
		content: Record<string, any> | null | undefined,
		completed: (...args: Array<any>) => any,
		failure: (...args: Array<any>) => any,
		timeout?: number,
		callTreeId?: string,
	) {
		xhttp.open(method, url, true);

		if (!callTreeId) {
			callTreeId = ClientSession.generateSessionedCallTreeIdWithPrefix("???PLAT");
		}

		xhttp.setRequestHeader("Content-type", "application/json; charset=utf-8");
		xhttp.setRequestHeader("CallTreeId", callTreeId!);

		xhttp.onreadystatechange = function () {
			if (xhttp.readyState === 4) {
				if (xhttp.status === 200) {
					completed.call(xhttp, xhttp);
				} else {
					failure.call(xhttp, xhttp);
				}
			}
		};

		xhttp.timeout = timeout ?? 5000;

		xhttp.ontimeout = function () {
			failure.call(xhttp, xhttp);
		};

		xhttp.send(content ? JSON.stringify(content) : undefined);
	},
	getPathQueryHash: function (url: string): string {
		const regex = /(?:https?:\/\/)?(?:[^?/]+)(.*)/;
		const result = (url || "").match(regex);

		if (result && result.length > 0) {
			if (result[1].startsWith("?")) {
				return "/" + result[1];
			}

			return result[1];
		}

		return "";
	},
};
